module.exports = __webpack_public_path__ + "img/splash-voie-veineuse.22b524ba.jpg";